import React from 'react';
import { Box, Drawer } from '@mui/material';
import { styled, makeStyles } from '@mui/styles';

import { P250DrawerDetails } from './P250DrawerComponents';

export const P250QuoteDrawer = ({ quote, toggle = false, setToggle }: any) => {
  const handleClose = () => setToggle(false);
  const classes = useStyles();

  return (
    <Drawer
      // @ts-expect-error TS(2322): Type '{ children: (Element | null)[]; pt: number; ... Remove this comment to see the full error message
      pt={2}
      anchor="right"
      open={toggle}
      onClose={handleClose}
      classes={classes}
      p={1}
    >
      <Title>Renewal Quote Details</Title>
      {quote ? <P250DrawerDetails quote={quote} /> : null}
    </Drawer>
  );
};

const useStyles = makeStyles(({ palette, config }) => ({
  paper: {
    width: '60.84rem',
    maxHeight: '62.34rem',
    padding: '0.9rem 1.25rem 0 1.25rem',
    color: palette.primary.main,
    backgroundColor: palette.background.modal,
    border: `1px solid ${palette.primary.border2}`,
    display: 'flex',
    alignItems: 'center',
    margin: 'auto 0',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 15,
    borderRadius: '0.5rem',
  },
  header: {
    fontSize: config.textSizes.tertia,
    textTransform: 'uppercase',
    margin: 0,
    marginBottom: '1.15rem',
    borderBottom: `1px solid ${palette.primary.modalBorder}`,
  },
}));

const Title = styled(Box)(({ theme }) => {
  const { config, palette } = theme;
  return {
    fontSize: config.textSizes.tertia,
    fontWeight: config.weights.bold,
    textTransform: 'uppercase',
    paddingBottom: '0.2rem',
    borderBottom: `1px solid ${palette.primary.modalBorder}`,
    marginBottom: '1rem',
  };
});
